"use client";

import { useEffect, useState } from "react";
import { Search, Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
function HeaderMenuConsumer() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <>
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          <NavigationMenuItem data-index={0}>
            <NavigationMenuLink asChild>
              <Link to="#featured-reviews" className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2 text-sm font-medium text-white transition-all duration-[var(--duration-medium)]">
                Featured Reviews
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link to="/#about-screenado" className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2 text-sm font-medium text-white transition-all duration-[var(--duration-medium)]">
                What is Screenado
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link to="/#how-it-works" className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2 text-sm font-medium text-white transition-all duration-[var(--duration-medium)]">
                How It Works
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link to="/#contact-feedback" className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2 text-sm font-medium text-white transition-all duration-[var(--duration-medium)]">
                Get In Touch
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link to="/ReviewLibraryPage" className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2 text-sm font-medium text-white transition-all duration-[var(--duration-medium)]">
                Review Library
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="md:hidden bg-primary text-foreground-primary" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-primary border-t border-primary-light/10 shadow-medium md:hidden z-50">
          <nav className="flex flex-col p-4 gap-2">
            <Link data-index={0} to="#featured-reviews" className="px-4 py-3 text-sm font-medium text-foreground-primary hover:bg-primary-hover rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
              Featured Reviews
            </Link>
            <Link to="/#about-screenado" className="px-4 py-3 text-sm font-medium text-foreground-primary hover:bg-primary-hover rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
              What is Screenado
            </Link>
            <Link to="/#how-it-works" className="px-4 py-3 text-sm font-medium text-foreground-primary hover:bg-primary-hover rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
              How It Works
            </Link>
            <Link to="/#contact-feedback" className="px-4 py-3 text-sm font-medium text-foreground-primary hover:bg-primary-hover rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
              Get In Touch
            </Link>
            <Link to="/ReviewLibraryPage" className="px-4 py-3 text-sm font-medium text-foreground-primary hover:bg-primary-hover rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
              Review Library
            </Link>
            <Link to="/#contact-feedback" className="mt-2" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-secondary text-foreground-secondary font-semibold px-6 py-2 rounded-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:bg-secondary-hover active:scale-100 active:bg-secondary-active shadow-soft" style={{
            borderRadius: "var(--radius-md)"
          }}>
                Request a Review
              </Button>
            </Link>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-[60px] bg-primary shadow-strong" : "h-[80px] bg-primary shadow-soft"}`} style={{
    borderRadius: "var(--radius-lg)",
    boxShadow: scrolled ? "inset 0 2px 4px rgba(0,0,0,0.12), var(--shadow-strong)" : "inset 0 1px 2px rgba(0,0,0,0.08), var(--shadow-soft)"
  }}>
      <div className="container mx-auto h-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-full">
          <Link to="/HomePage#" className="flex-shrink-0">
            <img src="https://notable-katydid.10web.cloud/wp-content/uploads/2026/02/Screenado-Banner-Text-Only.png" alt="Screenado" className="h-7 transition-all duration-[var(--duration-medium)]" />
          </Link>

          <div className="flex items-center gap-4">
            <MenuProvider menu_id="3" className="relative">
              <HeaderMenuConsumer />
            </MenuProvider>

            <div className="flex items-center gap-2">
              <div className="relative">
                {searchOpen ? <Input type="search" placeholder="Search..." className="w-48 h-9 bg-primary-light/10 border-primary-light/20 text-foreground placeholder:text-foreground focus-visible:border-secondary focus-visible:ring-secondary/50" autoFocus onBlur={() => setSearchOpen(false)} /> : <Button variant="ghost" size="icon" className="hover:!bg-transparent focus:!bg-transparent text-foreground-primary hover:text-foreground transition-all duration-[var(--duration-medium)]" onClick={() => setSearchOpen(true)} aria-label="Search">
                    <Search className="size-5" />
                  </Button>}
              </div>

              <Link to="/#contact-feedback">
                <Button className="bg-secondary text-foreground-secondary font-semibold px-6 py-2 rounded-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:bg-secondary-hover active:scale-100 active:bg-secondary-active shadow-soft" style={{
                borderRadius: "var(--radius-md)"
              }}>
                  Request a Review
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>;
}